import { AgGridReact } from 'ag-grid-react';
import gridFactory from './grid';
import getColumnIconsForInferredType from './get-column-icons-for-inferred-type';

const Grid = gridFactory(AgGridReact);

export default Grid;
export { Grid, getColumnIconsForInferredType };
